// @flow
import { useEffect, useState } from 'react';

import { useRouter } from './useRouter';

export function useRouterEvents(): RouterNavigationEvents {
  const [transitioning, setTransitioning] = useState(false);
  const { history } = useRouter<{}, {}>();

  useEffect(() => {
    const routeChangeStartHandler = () => {
      setTransitioning(true);
    };

    const routeChangeCompleteHandler = () => {
      setTransitioning(false);
    };

    history.events.on('routeChangeStart', routeChangeStartHandler);
    history.events.on('routeChangeComplete', routeChangeCompleteHandler);

    return () => {
      history.events.off('routeChangeStart', routeChangeStartHandler);
      history.events.off('routeChangeComplete', routeChangeCompleteHandler);
    };
  }, []);

  return { transitioning };
}
